import React, { FC, ReactNode } from 'react';
import Button from 'carbon-react/lib/components/button';

import { UISystemIcon } from '@futrli/ui-components';

interface Props {
  className?: string;
  onClick: () => void;
  testId?: string;
  children: ReactNode;
}

export const MasterfileButton: FC<Props> = ({ className, onClick, children, testId }) => (
  <Button buttonType="primary" className={className} onClick={onClick} data-testid={testId}>
    <UISystemIcon iconName="gsheets" />
    {children}
  </Button>
);
